/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, June 2020
 */

import React from 'react';
import { FlowBlockInput as BlockModel } from '@staffino/model';
import TextInputBlock from './text-input-block';
import DateInputBlock from './date-input-block';
import TimeInputBlock from './time-input-block';

type Props = {
  block: BlockModel;
};

export default function InputBlock({ block }: Props) {
  if (['String', 'Number', 'Email', 'Phone'].includes(block.inputType)) {
    return <TextInputBlock block={block} />;
  }
  if (['Date'].includes(block.inputType)) {
    return <DateInputBlock block={block} />;
  }
  if (['Time'].includes(block.inputType)) {
    return <TimeInputBlock block={block} />;
  }
  return null;
}
